import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { LinkTarget } from './p-link.types';

@Component({
    selector: 'p-link',
    template: ` <a
            *ngIf="!isRouterLink && url"
            class="p-paragraph-1"
            [href]="getUrlIfExists()"
            [target]="getTarget()"
            [class.disabled]="isReadOnly ? true : null"
            [ngClass]="isReadOnly ? 'p-link-disabled' : 'p-link-default'"
            [class.p-link-inherit-font-style]="inheritFontStyle"
        >
            <ng-container *ngTemplateOutlet="linkTmpl"></ng-container>
        </a>
        <a
            *ngIf="isRouterLink && url"
            class="p-paragraph-1"
            [routerLink]="getUrlIfExists()"
            [queryParams]="queryParams"
            [class.disabled]="isReadOnly ? true : null"
            [ngClass]="isReadOnly ? 'p-link-disabled' : 'p-link-default'"
            [class.p-link-inherit-font-style]="inheritFontStyle"
        >
            <ng-container *ngTemplateOutlet="linkTmpl"></ng-container>
        </a>
        <a
            *ngIf="!url"
            class="p-paragraph-1"
            [class.disabled]="isReadOnly ? true : null"
            [ngClass]="isReadOnly ? 'p-link-disabled' : 'p-link-default'"
            [class.p-link-inherit-font-style]="inheritFontStyle"
            ><ng-container *ngTemplateOutlet="linkTmpl"></ng-container
        ></a>
        <ng-template #linkTmpl>
            <ng-content></ng-content>
        </ng-template>`,
    styleUrls: ['./p-link.component.scss']
})
export class PLinkComponent {
    @Input() public isReadOnly = false;
    @Input() public url?: string;
    @Input() public target?: LinkTarget;
    @Input() public isRouterLink = false;
    @Input() public inheritFontStyle = false;
    @Input() public queryParams?: Params;

    @Output() public onClick = new EventEmitter<void>();

    @HostListener('click', ['$event'])
    public onLinkClick(event: Event): void {
        if (!this.url && !this.isReadOnly) {
            this.onClick.emit();
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }

    protected getUrlIfExists(): string {
        return this.url ?? '';
    }

    protected getTarget(): LinkTarget | '' {
        return this.target || this.getDefaultTarget();
    }

    protected getDefaultTarget(): '_blank' | '' {
        return this.url ? '_blank' : '';
    }
}
